<template>
	<div
		class="videoAndText paddingSize"
		:style="{
			marginTop: data.marginTop + 'px',
			paddingTop: data.paddingTop + 'px',
		}"
	>
		<div class="form_item" v-if="data.content || data.data.length > 0">
			<div class="form_item_title">
				<img src="../../assets/images/one.png" alt="" />
			</div>
			<div class="form_item_title title_name">
				<span>{{ data.content }}</span>
			</div>

			<div class="form_item_content">
				<div class="content_img">
					<video width="100%" controls v-for="(item, index) in data.data" :key="index" :poster="item.url">
						<source :src="data.videoUrl" type="video/mp4" />
						您的浏览器不支持 HTML5 video 标签。
					</video>
				</div>
				<div class="content_text">
					{{ data.details }}
				</div>
			</div>
		</div>

		<div class="form_item" v-else>
			<div class="form_item_title">
				<img src="../../assets/images/one.png" alt="" />
			</div>
			<div class="form_item_title title_name">
				<span>标题文字</span>
			</div>

			<div class="form_item_content">
				<div class="content_img">
					<video width="100%" controls poster="../../assets/images/video_poster.png">
						<source src="" type="video/mp4" />
						您的浏览器不支持 HTML5 video 标签。
					</video>
				</div>
				<div class="content_text">
					<div>中医文化现象是指中医的思维方式、传统习俗、行为规范、生活方式、文学艺术对大众生活的具体影响。</div>
					<div>中医四大学说是中医认知宇宙本原；阐明人体生理病理、指导临床实践；指导预防和治疗治病的基础。</div>
					<div>本课程内容对于中医确有专长医师完善理论基础、提高临床诊治率有极大帮助。</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'videoAndText',
	props: ['data'],
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/curriculum.scss';
.content_text {
	white-space: pre-line;
}
</style>